import { TournamentStatus } from '@okletsplay/core';
import { TournamentTeamEntity } from 'app/interfaces/entity';
import React, { FC } from 'react';
import { UserCardMenu } from 'shared/components/UserCardMenu';
import { withTournamentAdministrator } from 'shared/HOC/withTournamentAdministrator';
import { withTournamentStatus } from 'shared/HOC/withTournamentStatus';
import { CardAction } from 'shared/interfaces';

interface ManageTournamentTeamActionsProps {
  team: TournamentTeamEntity;
  actions: CardAction<TournamentTeamEntity>[];
}

const ManageTournamentTeamActionsComponent: FC<ManageTournamentTeamActionsProps> = ({
  team,
  actions,
}) => {
  return <UserCardMenu data={team} actions={actions} />;
};

export const ManageTournamentTeamActions = withTournamentStatus(
  withTournamentAdministrator(ManageTournamentTeamActionsComponent),
  [TournamentStatus.Pending, TournamentStatus.Checkin, TournamentStatus.Live]
);
